import { jsx as _jsx } from "react/jsx-runtime";
import { SPRING_CONFIG_QUICK } from '#pplx/frontend/aether/config.js';
import { animated, useTransition } from '@react-spring/web';
import { useCallback, useEffect, useRef } from 'react';
export const SourceSuggestions = function SourceSuggestions({ suggestions, onSuggestSource, onConnectSource, onSuggestionShown, onSuggestionClick, renderSuggestion, }) {
    const trackedSuggestionsRef = useRef(new Set());
    useEffect(() => {
        suggestions.forEach(({ source, connected }) => {
            if (trackedSuggestionsRef.current.has(source))
                return;
            trackedSuggestionsRef.current.add(source);
            onSuggestionShown?.({ source, connected });
        });
    }, [onSuggestionShown, suggestions]);
    const handleClick = useCallback((source, connected) => {
        onSuggestionClick?.({ source, connected });
        if (connected) {
            onSuggestSource(source);
        }
        else {
            onConnectSource(source);
        }
    }, [onSuggestionClick, onSuggestSource, onConnectSource]);
    const transitions = useTransition(suggestions, {
        keys: (item) => item.source,
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: SPRING_CONFIG_QUICK,
    });
    return transitions((style, item) => {
        // Return null for leaving items so they're removed from layout immediately
        // rather than holding their space while fading out.
        if (!suggestions.some((s) => s.source === item.source))
            return null;
        return (_jsx(animated.div, { style: style, className: "min-w-0", children: renderSuggestion({ source: item.source, connected: item.connected, onClick: handleClick }) }));
    });
};
//# sourceMappingURL=SourceSuggestions.js.map